<script>
  import View from '@/views/View'
  import LoadSections from '@/mixins/load-sections'
  export default {
    name: 'RedeemHistory',
    metaInfo: { title: 'Sejarah Redeem | Website Resmi Fitsea' },
    extends: View,
    mixins: [
      LoadSections([
        'RedeemHistory',
      ]),
    ],
    props: {
      id: {
        type: String,
        default: 'home',
      },
    },
  }
</script>
